export const hub_events = {
	action: {
		addingPaymentMethod: 'AddingPaymentMethod',
		freeSubscription: 'CreateFreeSubscription',
		successfulPaymentSignalRMethodName: 'SuccessfulPayment',
	},
	response: {
		subscriptionCanceled: 'SubscriptionCanceled',
		customerCreated: 'CustomerCreated',
		paymentSuccess: 'PaymentSuccess',
	},
};
